import React from "react";

export const Ganymede = () => {
  return (
    <div>
      <div
        id={"ganymede"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};

